export default __webpack_public_path__ + "static/media/solid.9661e94d.svg";